"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerBurnedBudgetAggregator = void 0;
const CustomerBurnedBudgetCombinationKey_1 = require("./CustomerBurnedBudgetCombinationKey");
class CustomerBurnedBudgetAggregator {
    constructor(emIds, opsTasks) {
        this.emIds = emIds;
        this.opsTasks = opsTasks;
        this.aggregated = {
            budgeted: 0,
            unbudgeted: 0,
            combinations: {},
        };
    }
    add(entry) {
        const userId = `${entry.user?.id}`;
        const taskId = `${entry.task?.id}`;
        const key = new CustomerBurnedBudgetCombinationKey_1.CustomerBurnedBudgetCombinationKey(entry.budgeted, this.emIds.has(userId), this.opsTasks.has(taskId));
        const keyStr = (0, CustomerBurnedBudgetCombinationKey_1.serializeCustomerBurnedBudgetCombinationKey)(key);
        if (entry.budgeted) {
            this.aggregated.budgeted += entry.hours;
        }
        else {
            this.aggregated.unbudgeted += entry.hours;
        }
        if (!this.aggregated.combinations[keyStr]) {
            this.aggregated.combinations[keyStr] = 0;
        }
        this.aggregated.combinations[keyStr] += entry.hours;
    }
}
exports.CustomerBurnedBudgetAggregator = CustomerBurnedBudgetAggregator;
//# sourceMappingURL=CustomerBurnedBudgetAggregator.js.map